import React, { useState, useEffect } from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import {
  // Comment by Mohammed Shawwa | 2023-03-22
  /* getUserTotalTELVAvailable,
  getUserTotalTELVOwned,
   getUserTotalTELVClaimed,*/
  getHolder,
  schedule,
  claimAvailableTELV,
} from "../../vestingContractFunctions";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { toast } from "react-hot-toast";
import { useDebounce } from "../../../../Helper/Helper";
import { useContext } from "react";
import { AppContext } from "../../../../scripts/context";

function BalanceDetails() {
  // own values
  const [progressPercent, setProgressPercent] = useState(0);
  const { loading } = useContext(AppContext);
  // values from contract
  // Comment by Mohammed Shawwa | 2023-03-22
  /*
    const [lastUnlockDate, setLastUnlockDate] = useState('');
  const [totalTELVAvailable, setTotalTELVAvailable] = useState(0);
  const [totalTELVClaimed, setTotalTELVClaimed] = useState(0);
  const [totalTELVOwned, setTotalTELVOwned] = useState(0);*/
  const [holder, setHolder] = useState({});

  // refresh values from contract
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    schedule().then((res) => {
      // Comment by Mohammed Shawwa | 2023-03-22
      // setLastUnlockDate(formatDate(res[res.length - 1].date));
    });
    getHolder().then((res) => {
      setHolder(res);
    });

    // Comment by Mohammed Shawwa | 2023-03-22
    /*getUserTotalTELVAvailable().then((res) => {
      setTotalTELVAvailable(res);
    });
    getUserTotalTELVClaimed().then((res) => {
      setTotalTELVClaimed(res);
    });
    getUserTotalTELVOwned().then((res) => {
      setTotalTELVOwned(res);
    });*/
  }, [refresh, loading]);

  useEffect(() => {
    if (holder.totalClaimed && holder.balance)
      setProgressPercent((holder.totalClaimed / holder.balance) * 100);
  }, [holder.totalClaimed, holder.balance]);

  // format date from 12/6/2022, 19:00:00 to 12.06.2022 19:00:00
  const formatDate = (date) => {
    const dateArray = date.split(",");
    const dateArray2 = dateArray[0].split("/").join(".");
    const newDate = `${dateArray2} ${dateArray[1]}`;
    return newDate;
  };

  const handleClaim = async (e) => {
    e.stopPropagation();
    if (!holder.availableClaim) {
      toast.error("No BULT available to claim");
      return;
    }

    try {
      await claimAvailableTELV();
      toast.success("Claimed successfully");
      setRefresh(!refresh);
    } catch (error) {
      toast.error("Claim failed! Please try again later.");
      console.log(error);
    }
  };

  // const debouncedHandleClaim = debounce(handleClaim, 1000);
  const debouncedHandleClaim = useDebounce(handleClaim, 1000);
  return (
    <>
      <h2 className="table-label">You Own {holder.balance} BULT</h2>
      <Row className="bg-balance-details align-items-center justify-content-center shared-margin shared-space ">
        <Col xs={10} className="live-buy-section">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-left">
              <span className="text-muted">Claimed</span>
              <p>{holder.totalClaimed} BULT</p>
            </div>

            <div>
              <div className="text-right">
                <span className="text-muted">Next Unlock:</span>
                <p>{holder.balance > 0 && holder.nextUnlockDate}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-left">
              <span className="text-muted">Of</span>
              <p>{holder.balance} BULT</p>
            </div>
          </div>
          <div>
            <div className="pb-8">
              <ProgressBar now={progressPercent} />
            </div>

            <span className="text-muted">{Math.round(progressPercent)} %</span>
            {/* <hr /> */}
          </div>

          <div className="fees-data">
            <div>
              <h6>Claimed</h6>
              <h2>{holder.totalClaimed}</h2>
            </div>
            <div>
              <h6>Ready to Claim</h6>
              <h2>{holder.availableClaim}</h2>
            </div>
            <div>
              <h6>Locked Balance</h6>
              <h2>
                {parseFloat(holder.balance - (holder.availableClaim + holder.totalClaimed)).toFixed(2)}
              </h2>
            </div>
            {/* <hr /> */}
          </div>

          <div className="fees-data">
            <div>
              <h6>Total Balance</h6>
              <h2>{holder.balance}</h2>
            </div>
          </div>

          <div>
            <span onClick={debouncedHandleClaim} className="presale-submit-btn">
              {holder.availableClaim > 0
                ? `Claim ${holder.availableClaim} BULT`
                : "No BULT to Claim"}
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default BalanceDetails;
